import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import server from 'server/serverController2';
import { UserInfoActions, UserPermissionActions } from 'store/actionCreators';

import AccountDeleteConfirm from 'components/presenters/withdrawal/AccountDeleteConfirm';
import AccountSurveyForm from 'components/presenters/withdrawal/AccountSurveyForm';
import CenterModal from 'components/presenters/modal/CenterModal';

export default function AccountDeleteForm(){
    const userInfo = useSelector((status) => {
        return status['userInfo'];
    })

    const [surveysOptions, setSurveyOptions] = useState([]);
    const [isChecked, setisChecked] = useState(false);
    const [currDeleteReason, setCurrDeleteReason] = useState(null);
    const [isCheckedOption, setIsCheckedOption] = useState(false);
    const [currDeleteOptionNo, setCurrDeleteOptionNo] = useState(null);
    const [valid, setValid] = useState(false);
    const [etcReason, setEtcReason] = useState(null);
    // CenterModal
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState(null);
    const [centerModalComplete, setCenterModalComplete] = useState(null);
    const [centerModalCancel, setCenterModalCancel] = useState(null);
    const [initCenterModalState, setInitCenterModalState] = useState(false);

    const history = useHistory();

    const handleChangeCheck = (e) => {
        setisChecked(e.target.checked);
    }

    const handleClickRadio = (e, reason, optionNo) => {
        setCurrDeleteReason(reason);
        setIsCheckedOption(e.target.checked)
        setCurrDeleteOptionNo(optionNo);
    }

    const handleChangeEtc = (e) => {
        setEtcReason(e.target.value);
    }

    const handleClickCancel = () => {
        history.goBack();
    }

    const handleSubmit = () => {
        let reason = null;
        if(etcReason !== null && etcReason !== '')
        {
            reason = etcReason
        }
        else
        {
            reason = currDeleteReason
        }
        const body = {
            option_no: currDeleteOptionNo,
            reason: reason
        }
        server.deleteRequestData(`users/${userInfo['id']}`, body, (res) => {
            try
            {
                if(res['success'] !== 1)
                {
                    return;
                }
                UserInfoActions.initUserState({});
                UserPermissionActions.initUserPermission({});
                setCenterModalDataList({description: `회원 탈퇴가 완료되었어요 \n 더 발전하는 모티너스가 되겠습니다🙌`});
                setCenterModalComplete(() => () => history.replace('/'));
                setCenterModalCancel(null);
                setCenterModalVisible(true);
            }
            catch(err)
            {
                console.log(err);
            }
        })
    }

    const initCallback = (res) => {
        try
        {
            if(res['success'] !== 1)
            {
                return;
            }
            const options = res['data']['options'];
            setSurveyOptions(options);
        }
        catch(err)
        {
            console.log(err);
        }
    }

    useEffect(() => {
        server.getRequestData(`surveys/accounts/deletes/options?activate=true&order_by=option_order&order=asc`, initCallback);
    }, [])

    useEffect(() => {
        if(currDeleteReason && currDeleteOptionNo && isChecked)
        {
            if(currDeleteReason === '기타' && (etcReason === null || etcReason === ''))
            {
                setValid(false);
                return;
            }
            setValid(true);
        }
        else
        {
            setValid(false);
        }
    }, [currDeleteReason, currDeleteOptionNo, isChecked, etcReason])

    return (
        <>
            <AccountDeleteFormWrapper>
                <AccountDeleteConfirm 
                    isChecked={isChecked}
                    handleChangeCheck={handleChangeCheck}
                />
                <AccountSurveyForm 
                    options={surveysOptions}
                    handleClickRadio={handleClickRadio}
                    currDeleteReason={currDeleteReason}
                    isCheckedOption={isCheckedOption}
                    handleSubmit={handleSubmit}
                    valid={valid}
                    handleChangeEtc={handleChangeEtc}
                    handleClickCancel={handleClickCancel}
                />
            </AccountDeleteFormWrapper>
            <CenterModal 
                modalVisible={centerModalVisible} 
                dataList={centerModalDataList} 
                onComplete={centerModalComplete} 
                onCancel={centerModalCancel}
            />
        </>
    )
}

const AccountDeleteFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;